import React, { useContext } from 'react';
import { Context } from '@store/store';
import GoBackToMainMenuButton from '../go-back-to-main-menu-button';
import {
  StyledTOCSidebar,
  StyledTOCList,
  Header,
  StyledLine,
} from './toc-sidebar.styles';

const TOCSidebar = ({ toc }) => {
  const [state, dispatch] = useContext(Context);
  const generateTOCList = tocArray => {
    return tocArray.map((tocElement, index) => {
      const page = parseInt(tocElement.href.slice(3), 16);
      const itemList = (
        <li
          key={`inner_list_${index}`}
          onClick={() => {
            dispatch({
              type: 'SET_CURRENT_PAGE',
              payload: page - 1,
            });
            dispatch({ type: 'TOGGLE_MAIN_MENU_SIDEBAR' });
          }}
        >
          {tocElement.text}
        </li>
      );
      return tocElement.children ? (
        <React.Fragment key={index}>
          {itemList}
          <StyledTOCList>{generateTOCList(tocElement.children)}</StyledTOCList>
        </React.Fragment>
      ) : (
        itemList
      );
    });
  };

  return (
    <StyledTOCSidebar isOpened={state.isTOCSidebarOpened}>
      <Header>
        <GoBackToMainMenuButton />
        <span>Оглавление</span>
        <span></span>
      </Header>
      <StyledLine />
      {toc ? (
        <StyledTOCList>{generateTOCList(JSON.parse(toc))}</StyledTOCList>
      ) : (
        <p>К сожалению, оглавление для данного документа отсутствует.</p>
      )}
    </StyledTOCSidebar>
  );
};

export default TOCSidebar;
